import { FilterDisplaySettings } from "./filterSettings";
import { getAuthHeaders, API_BASE_URL } from "./api";

const API_URL = `${API_BASE_URL}/filter-settings`;

export async function fetchFilterSettings(): Promise<
  Record<string, FilterDisplaySettings>
> {
  const headers = getAuthHeaders();
  console.log("Fetching filter settings with auth headers");

  const res = await fetch(API_URL, {
    headers,
  });

  if (!res.ok) throw new Error("Failed to fetch filter settings");
  return res.json();
}

export async function saveFilterSettings(
  settings: Record<string, FilterDisplaySettings>
) {
  const headers = getAuthHeaders();
  console.log("Saving filter settings with auth headers");

  const res = await fetch(API_URL, {
    method: "POST", // Changed from PUT to POST to match the server endpoint
    headers: {
      ...headers,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(settings),
  });

  if (!res.ok) throw new Error("Failed to save filter settings");
  return res.json();
}
